import { render, staticRenderFns } from "./SystemCodeDetail.vue?vue&type=template&id=2ec82c7b&scoped=true&"
import script from "./SystemCodeDetail.vue?vue&type=script&lang=js&"
export * from "./SystemCodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec82c7b",
  null
  
)

export default component.exports